module.exports = __webpack_public_path__ + "img/36_73.004bd040.png";